// extracted by mini-css-extract-plugin
module.exports = {"block":"MegaBoardModule_block__0ISTT","footer":"MegaBoardModule_footer__QnN3n","list":"MegaBoardModule_list__wTtbP"};